var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scroll-vertical full-height big-spacer related-users"},_vm._l((_vm.users),function(user){return _c('div',{key:user.uid,staticClass:"spacer"},[_c('alert-log-user',{attrs:{"user":user,"related":_vm.related}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }